import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../style/userLayout.css';
import '../style/solicitorLayoutHeader.css'

class HeaderItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    toggleMenu = () => { this.setState({isOpen: !this.state.isOpen})};

    closeMenu = () => { this.setState({isOpen: false})};

    openMenu = () => { this.setState({isOpen: true})};

    render() {
        let icon = '';
        if (this.props.icon !== undefined && this.props.icon > 0) icon =
            <span className="notifications-icon">{this.props.icon}</span>;
        if (this.props.isDropDown) {
            return (
                <div className={"user-layout-header-link-div no-select"}>
                    <div
                        onClick={this.toggleMenu}
                        className={"user-layout-header-link" + ' dropdown ' + (this.state.isOpen ? 'open' : '')}
                    >
                        <span onMouseOver={this.openMenu}> {this.props.title}</span>
                        <span className="caret"></span>
                        <ul className="dropdown-menu" onMouseLeave={this.closeMenu}>
                            {
                                this.props.dropDownMenu.map((i, index) => {
                                    return <li key={index}>
                                        <NavLink onClick={() => null} to={i.href}>{i.title}</NavLink>
                                    </li>
                                })
                            }
                        </ul>
                    </div>
                </div>
            )
        }
        return (
            <div className="user-layout-header-link-div">
                <NavLink to={this.props.href} className="user-layout-header-link"
                         activeClassName="solicitor-layout-header-link-active">{this.props.title} {icon}</NavLink>
            </div>
        )
    }
}

export default HeaderItem;